import React from "react";
import { Typography, Space, Button } from "antd";
import { useConsultationSchedulingState } from "./State";
import translator from "@/translator";

const { Text } = Typography;
const t = translator("front_office.views.onboarding.amo_consultation_scheduling.");

const Finish = () => {
  const { state } = useConsultationSchedulingState();
  const { call_now, date_time } = state;

  return (
    <Space direction="vertical" size={32}>
      <img src="/onboarding/consultation_scheduling_3.svg" alt="" />
      <Space direction="vertical" size={8}>
        <Text strong>
          {call_now ? t("finish.call_now_title") : t("finish.call_scheduled_title", { date_time })}
        </Text>
        <Text>
          {call_now ? t("finish.call_now_description") : t("finish.call_scheduled_description")}
        </Text>
      </Space>
      <Text>{call_now ? t("finish.call_now_note") : t("finish.call_scheduled_note")}</Text>
      {call_now && (
        <Button href="/front_office" className="ant-custom-btn" block type="primary">
          {t("finish.dashboard_button")}
        </Button>
      )}
    </Space>
  );
};

export default Finish;
